window.dtHoliday = function () {
  const dt_holiday = new DataTable('#holiday-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#holiday-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#holiday-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "date" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 